import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';

import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';

import { Events } from '@providers/common/events.service';
import { MyImageSwiperViewModal } from '@components/my-image-swiper-view/my-image-swiper-view.component';
import { MyImageSwiperPreviewModal } from '@components/my-image-swiper-preview/my-image-swiper-preview.component';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";

register();

@Component({
    selector: 'modal-full-resume-detail',
    templateUrl: './modal-full-detail.component.html',
    styleUrls: ['./modal-full-detail.component.scss'],
    standalone: false,
})
export class FullResumeDetailChatAIModal implements OnInit {
    @Input('modalTitle') modalTitle: string = '';
    @Input('resumeDetail') resumeDetail: string = '';
    @Input('tableFinanceDetail') tableFinanceDetail: string = '';
    @Input('tableOperationsDetail') tableOperationsDetail: string = '';
    @Input('tableDetail') tableDetail: string = '';
    @Input('chartDetail') chartDetail: string = '';
    @Input('chartsDetail') chartsDetail: string[] = [];

    @ViewChild('chartsCarousel') set chartsCarousel(el: ElementRef | undefined) {
        if (el) {
            Object.assign(el.nativeElement, this.config);
            el.nativeElement.initialize();
        }
    }
    config: SwiperOptions = {
        centeredSlides: true,
        slidesPerView: 1,
        navigation: true,
        loop: true,
        pagination: false,
        initialSlide: 0,
        // pagination: { clickable: true, dynamicBullets: true },
    };
    imagesSlider: string[] = [];

    sliderOpt = {
        zoom: false,
        centeredSlides: true,
    };

    constructor(
        private modalCtrl: ModalController,
        private events: Events,
    ) {
        this.events.publish('menulat:togglevisibility');
        addIcons({ close });
    }

    ngOnInit() {
        console.log('Charts: ', this.chartsDetail);
        console.log('Chart: ', this.chartDetail);
    }

    /**
     * @name dismiss
     * @desc Metodo que te regresa en la navegación
     **/
    dismiss() {
        this.events.publish('menulat:togglevisibility');
        this.modalCtrl.dismiss();
    }

    async onOpenImageViewerModal(imageURL: string) {
        const modal = await this.modalCtrl.create({
            component: MyImageSwiperPreviewModal,
            componentProps: {
                urlImage: imageURL,
            },
            cssClass: 'fullscreen transparent-modal',
        });

        modal.present();
    }

    async onOpenImageSwiperModal(imageIdx: number) {
        const swiperModal = await this.modalCtrl.create({
            component: MyImageSwiperViewModal,
            componentProps: {
                imagesURLs: this.chartsDetail,
                initialSlide: imageIdx,
            },
            cssClass: 'fullscreen transparent-modal',
        });
        return await swiperModal.present();
    }

    onSwiper(event: any) {
        // console.log(event);
    }

    onSlideChange() {
        console.log('slide change');
    }
}
